module.exports = __webpack_public_path__ + "img/closeIcon.78df7a5c.svg";